import { TokenType } from '../enums/token-type';

const TOKEN_KEY = 'token';

class TokenService {
  getToken() {
    try {
      const tokenModel = localStorage.getItem(TOKEN_KEY);
      if (tokenModel) {
        return JSON.parse(tokenModel).token;
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  setToken(tokenType, token) {
    try {
      const tokenModel = {
        tokenType: tokenType,
        token: token,
      };
      localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenModel));
    } catch (error) {
      console.error('Token kaydetme hatası:', error);
    }
  }

  getTokenType() {
    try {
      const tokenModel = localStorage.getItem(TOKEN_KEY);
      if (tokenModel) {
        return JSON.parse(tokenModel).tokenType;
      }
      return TokenType.None;
    } catch (error) {
      return TokenType.None;
    }
  }

  removeToken() {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch (error) {
      console.error('Token silme hatası:', error);
    }
  }
}

export default new TokenService();
